/* eslint @typescript-eslint/naming-convention: 0 */

import { buildWabunkaItemParamsByExperienceEvent, type ItemParams } from '@/wabunka-src/common/utils/googleAnalytics/common/wabunkaItem';
import { type Currency } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';
import type { WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';

export interface AddPaymentCardParams {
  currency: Currency;
  items: ItemParams[];
}

const buildAddPaymentCardParams = (experienceEvent: WabunkaExperienceEventViewModel): AddPaymentCardParams => {
  const item = buildWabunkaItemParamsByExperienceEvent(experienceEvent);
  return {
    currency: 'JPY',
    items: [item],
  };
};

/**
 * 発火タイミング：支払いカード情報入力完了時
 */
export const sendGAWabunkaAddPaymentCardInfoEvent = (experienceEvent: WabunkaExperienceEventViewModel) => {
  sendWabunkaGAEvent('add_payment_card', buildAddPaymentCardParams(experienceEvent));
};
